import { TextField, MenuItem } from "@mui/material"
import { useState, useEffect } from "react"
import { Tags as API } from "../../../services/API/Tags";

export default function TagTypeSelect({value, onChange, required, disabled}){

    const [types, setTypes] = useState([]);
    const [val, setVal] = useState('')

    useEffect(() => {
        API.getTypes()
            .then(r => {
                setTypes(Array.isArray(r.data) ? r.data : [])
                return setVal(value);
            })
            .catch(e => console.log(e))
    }, [value])

    const handleChange = id => {
        setVal(id);
        return onChange(id);
    }

    return <TextField
        label='Catégorie de mot clé'
        select
        size='small'
        value={val}
        onChange={e => handleChange(e.target.value)}
        fullWidth
        required={required ? true : false}
        disabled={disabled}
    >
        {!required && <MenuItem value='all'>Tous</MenuItem>}
        {types.map(t => 
            <MenuItem key={t.id} value={t.id}>{t.title}</MenuItem>    
        )}
    </TextField>
}